import { all } from 'redux-saga/effects';
import authSagas from './Auth';
import modeloSagas from './Modelo';
import equipamentoSagas from './Equipamento';
import clienteSagas from './Cliente';
import localControladoSagas from './LocalControlado';
import pontoAcessoSagas from './PontoAcesso';
import perfilSagas from './Perfil';
import perfilPortalSagas from './PerfilPortal';
import usuarioPlataformaSagas from './UsuarioPlataforma';
import usuarioPortalSagas from './UsuarioPortal';
import acessoPessoaSagas from './AcessoPessoa';
import acessoPerfilSagas from './AcessoPerfil';
import acessoGeneroSagas from './AcessoGenero';
import acessoIdadeSagas from './AcessoIdade';
import acessoPeriodoSagas from './AcessoPeriodo';
import acessoFullSagas from './AcessoFull';
import acessoBloqueioSagas from './AcessoBloqueio';
import localidadeSagas from './Localidade';
import vinculoPessoaSagas from './VinculoPessoa';
import inicioSagas from './Inicio';
import unidadeSagas from './Unidade';
import categoriaSagas from './Categoria';
import titularidadeSagas from './Titularidade';
import ambienteSagas from './Ambiente';
import portarioInicioSagas from './PortariaInicio';
import escolaSagas from './Escola';
import alunoSagas from './Aluno';
import notificacaoSagas from './Notificacao';
import cursoSagas from './Curso';
import serieSagas from './Serie';
import disciplinaSagas from './Disciplina';
import turmaSagas from './Turma';
import tipoTurmaSagas from './TipoTurma';
import matriculaSagas from './Matricula';
import rematriculaSagas from './Rematricula';
import anoLetivoSagas from './AnoLetivo';
import calendarioSagas from './Calendario';
import sequenciaEnturmacaoSagas from './SequenciaEnturmacao';
import seriesEscolaSagas from './SeriesEscola';
import componentesSerieSagas from './ComponentesSerie';
import areaConhecimentoSagas from './AreaConhecimento';
import dashboardPresencaSagas from './Presenca';
import regrasAvaliacaoSagas from './RegrasAvaliacao';
import recuperaSenhaSagas from './RecuperarSenhaApp';
import enquetesSagas from './Enquetes';
import notasFaltasSagas from './NotasFaltas';
import atividadesPedagogicasSagas from './AtividadesPedagogicas';
import cantinaSagas from './Cantina';
import diarioSagas from './Diario';
import justificativaFaltaSagas from './JustificativaFalta';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    calendarioSagas(),
    inicioSagas(),
    modeloSagas(),
    equipamentoSagas(),
    clienteSagas(),
    localControladoSagas(),
    pontoAcessoSagas(),
    perfilSagas(),
    perfilPortalSagas(),
    usuarioPlataformaSagas(),
    usuarioPortalSagas(),
    acessoPessoaSagas(),
    acessoPerfilSagas(),
    acessoGeneroSagas(),
    acessoIdadeSagas(),
    acessoPeriodoSagas(),
    acessoFullSagas(),
    acessoBloqueioSagas(),
    localidadeSagas(),
    vinculoPessoaSagas(),
    unidadeSagas(),
    categoriaSagas(),
    titularidadeSagas(),
    ambienteSagas(),
    portarioInicioSagas(),
    escolaSagas(),
    alunoSagas(),
    cursoSagas(),
    serieSagas(),
    disciplinaSagas(),
    turmaSagas(),
    tipoTurmaSagas(),
    matriculaSagas(),
    rematriculaSagas(),
    anoLetivoSagas(),
    sequenciaEnturmacaoSagas(),
    seriesEscolaSagas(),
    componentesSerieSagas(),
    areaConhecimentoSagas(),
    dashboardPresencaSagas(),
    regrasAvaliacaoSagas(),
    notificacaoSagas(),
    enquetesSagas(),
    recuperaSenhaSagas(),
    notasFaltasSagas(),
    atividadesPedagogicasSagas(),
    cantinaSagas(),
    diarioSagas(),
    justificativaFaltaSagas()
  ]);
}
